import { RegexUtils } from "../../../utils";
// datetime
export const REGEX_YEAR = /\d{4}/; // 4桁の数字
export const REGEX_MONTH = /(?:0?[1-9]|1[0-2])/; // 1~12(0埋めOK)
export const REGEX_DAY = /(?:0?[1-9]|[12][0-9]|3[01])/; // 1~31(0埋めOK)
export const REGEX_HOUR = /(?:0?[0-9]|1[0-9]|2[0-3])/; // 0~23(0埋めOK)
export const REGEX_HOUR_PADDED = /(?:0[0-9]|1[0-9]|2[0-3])/; // 0~23(0埋め必須)
export const REGEX_MINUTE = /(?:0?[0-9]|[1-5][0-9])/; // 00~59(0埋OK)
export const REGEX_MINUTE_PADDED = /(?:0[0-9]|[1-5][0-9])/; // 00~59(0埋必須)
export const REGEX_SECOND = /(?:0?[0-9]|[1-5][0-9])/; // 00~59(0埋めOK)
export const REGEX_SECOND_PADDED = /(?:0[0-9]|[1-5][0-9])/; // 00~59(0埋め必須)
export const REGEX_MILLISECOND = /(?:[0-9]{1,3})/; // 0~999(0埋めOK)
export const REGEX_DAY_OF_WEEK = /(?:[(][月火水木金土日][)])/; // 月~日(括弧付き)
// 月の正規表現。 2020-01, 2020/01, 2020年01月 などにマッチする
const REGEX_YEAR_MONTH = RegexUtils.or([
    RegexUtils.concat([REGEX_YEAR, /[-/]/, REGEX_MONTH]),
    RegexUtils.concat([REGEX_YEAR, /年/, REGEX_MONTH, /月/]),
]);
// 日付の正規表現。 2020-01-01, 2020/01/01, 2020年01月01日(火) などにマッチする
const REGEX_DATE = RegexUtils.or([
    RegexUtils.concat([REGEX_YEAR, /[-/]/, REGEX_MONTH, /[-/]/, REGEX_DAY]),
    RegexUtils.concat([
        REGEX_YEAR,
        /年/,
        REGEX_MONTH,
        /月/,
        REGEX_DAY,
        /日/,
        RegexUtils.repeat(REGEX_DAY_OF_WEEK, "?"),
    ]),
]);
// 時刻の正規表現。 10:00, 10:00:00, 10:00:00.000, 10時00分, 10時00分00秒, 10時00分00秒000 などにマッチする
const REGEX_TIME = RegexUtils.or([
    RegexUtils.concat([
        REGEX_HOUR,
        /:/,
        REGEX_MINUTE,
        RegexUtils.repeat(RegexUtils.concat([/:/, REGEX_SECOND]), "?"),
        RegexUtils.repeat(RegexUtils.concat([/\./, REGEX_MILLISECOND]), "?"),
    ]),
    RegexUtils.concat([
        REGEX_HOUR,
        /時/,
        REGEX_MINUTE,
        /分/,
        RegexUtils.repeat(RegexUtils.concat([REGEX_SECOND, /秒/]), "?"),
        RegexUtils.repeat(REGEX_MILLISECOND, "?"),
    ]),
]);
// HHMMSS方式で、必ずゼロ埋めされている時刻の正規表現
export const REGEX_HHMMSS = RegexUtils.concat([
    REGEX_HOUR_PADDED,
    REGEX_MINUTE_PADDED,
    REGEX_SECOND_PADDED,
]);
// 年の正規表現。 2020,2020年などにマッチする
export const REGEX_LOCAL_YEAR = RegexUtils.or([
    REGEX_YEAR,
    RegexUtils.concat([REGEX_YEAR, /年/]),
]);
export const REGEX_LOCAL_YEAR_MONTH = RegexUtils.concat([
    /^/,
    REGEX_YEAR_MONTH,
    /$/,
]);
export const REGEX_LOCAL_DATE = RegexUtils.concat([/^/, REGEX_DATE, /$/]);
export const REGEX_LOCAL_TIME = RegexUtils.concat([/^/, REGEX_TIME, /$/]);
export const REGEX_LOCAL_DATE_TIME = RegexUtils.concat([
    /^/,
    REGEX_DATE,
    /\D*/,
    REGEX_TIME,
    /$/,
]);
//# sourceMappingURL=time-regex.js.map